import {APIMethod} from '@enums'

import {fetchData} from 'api/api'

import {DealerRequest, DealerResponse} from './types'

export const getAllDealers = () =>
  fetchData<undefined, DealerResponse[]>({
    method: APIMethod.GET,
    url: 'dealer',
  })

export const getDealersByCompany = (companyId: string) =>
  fetchData<undefined, DealerResponse[]>({
    method: APIMethod.GET,
    url: `dealer/company/${companyId}`,
  })

export const getDealerById = (id: string) =>
  fetchData<undefined, DealerResponse>({
    method: APIMethod.GET,
    url: `dealer/${id}`,
  })

export const createDealer = (body: DealerRequest) =>
  fetchData<DealerRequest, DealerResponse>({
    method: APIMethod.POST,
    url: 'dealer',
    body,
  })

export const updateDealer = (id: string, body: DealerRequest) =>
  fetchData<DealerRequest, DealerResponse>({
    method: APIMethod.PUT,
    url: `dealer/${id}`,
    body,
  })

export const linkDealerToContractType = async (dealerId: string, contractTypeId: string): Promise<void> => {
  await fetchData<void>({
    method: APIMethod.POST,
    url: `dealer/${dealerId}/contract-type/${contractTypeId}`,
  })
}

export const unlinkDealerFromContractType = async (dealerId: string, contractTypeId: string): Promise<void> => {
  await fetchData<void>({
    method: APIMethod.DELETE,
    url: `dealer/${dealerId}/contract-type/${contractTypeId}`,
  })
}
